<template>
  <div>
    <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
    <b-row class="mx-0">
      <b-col>
        <div
          style="font-family: 'Poppins', sans-serif; font-size: x-large; color: #e8661a;"
        >
          {{authorData.name}} {{authorData.lastname}}
        </div>
        <div style="font-family: 'Poppins', sans-serif; font-size: larger;">
          {{authorData.resumemin}}
        </div>
        <img
          class="rounded d-block d-md-none mt-4"
          :src="$store.state.user.siteData.location +
                'repository/authors/' + authorData.id  + '_big'"
          style="max-width: 100%; max-height: 100%; height: 30rem;"
        />
        <div class="mt-4 small">
          <span v-html="authorData.resume"></span>
        </div>
        <div class="mt-2 text-right" style="color: #e8661a;">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="instagram"
            style="cursor: pointer;"
            class="mr-2"
            role="img"
            viewBox="0 0 448 512"
            width="1em"
            height="1em"
            v-if="authorData.socialinst"
            @click="openLink(authorData.socialinst);"
          >
            <path
              fill="currentColor"
              d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="twitter"
            style="cursor: pointer;"
            class="mr-2"
            role="img"
            viewBox="0 0 512 512"
            width="1em"
            height="1em"
            v-if="authorData.socialtwitter"
            @click="openLink(authorData.socialtwitter);"
          >
            <path
              fill="currentColor"
              d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="facebook-f"
            style="cursor: pointer;"
            class="mr-2"
            role="img"
            viewBox="0 0 320 512"
            width="1em"
            height="1em"
            v-if="authorData.socialfb"
            @click="openLink(authorData.socialfb);"
          >
            <path
              fill="currentColor"
              d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="facebook-f"
            style="cursor: pointer;"
            class="mr-2"
            role="img"
            viewBox="0 0 320 512"
            width="1em"
            height="1em"
            v-if="authorData.sociallin"
            @click="openLink(authorData.sociallin);"
          >
            <path xmlns="http://www.w3.org/2000/svg" fill="currentColor" d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"/>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="facebook-f"
            style="cursor: pointer;"
            class="mr-2"
            role="img"
            viewBox="0 0 496 512"
            width="1em"
            height="1em"
            v-if="authorData.website"
            @click="openLink(authorData.website);"
          >
            <path
              fill="currentColor"
              d="M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"
              class
            />
          </svg>
        </div>
      </b-col>
      <b-col class="d-none d-md-block text-center">
        <img
          class="rounded"
          :src="$store.state.user.siteData.location +
                'repository/authors/' + authorData.id  + '_big'"
          style="max-width: 100%; max-height: 100%; height: 30rem;"
        />
      </b-col>
    </b-row>
    <div
      class="mt-5 p-5 d-flex flex-column flex-md-row align-items-center"
      style="background: #c8c3c240; border-radius: 1rem; color:  #e8661a; font-family: 'Poppins', sans-serif; font-size: large; "
      v-if="authorData.phrase"
    >
      <b-avatar style="background-color: #e8661a;" class="mb-2 mb-md-0" />
      <div style="flex-shrink: 100; margin-left: 2rem; font-weight: 200;">
        "{{authorData.phrase}}"
      </div>
    </div>
    <main-title :title="'Libros de ' + authorData.name + ' ' + authorData.lastname" />
    <book-list :items="authorBooks" />
  </div>
</template>
<script>
import MainTitle from "@/components/MainTitle.vue";
import BookList from "@/components/BookList.vue";
import axios from "axios";

export default {
  components: {
    MainTitle,
    BookList
  },
  data: function() {
    return {
      breadcrumb: [
        {
          text: "Inicio",
          to: { name: "Home" }
        },
        {
          text: "Autores",
          to: { name: "Autores" }
        },
        {
          text: "E",
          to: { name: "Autores" }
        },
        {
          text: "Eugenia Etkin",
          active: true
        }
      ],
      authorData: {
        id: 0,
        name: '',
        resumemin: '',
        resume: '',
        phrase: '',
        socialinst: '',
        socialtwitter: '',
        socialfb: '',
        website: ''
      },
      authorBooks: []
    };
  },
  mounted(){
    this.updateAuthor();
  },
  computed: {
    demo: function() {
      const result = [];
      for (let page = 0; page < 2; page++) {
        for (let bookData = 1; bookData < 5; bookData++) {
          result.push({
            imgCover: "img/7.png",
            bookTitle: "Comunicación y periodismo",
            bookDesc: "Sivana Comba y Edgardo Toledo",
            bookId: bookData + page * 4,
            size: 25
          });
        }
      }
      return result;
    }
  },
  methods:{
    async updateAuthor(){
      console.log(this.$store.state.user.siteData);
      
      this.authorData = await axios
        .post(
          this.$store.state.user.siteData.location + "authors/authors/getOne",
          JSON.stringify({id: this.$route.params.id}),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          let result = {};
          result = evtResponse.data.records[0];
          if (result.lastname){
            this.breadcrumb[2].text = result.lastname[0];
            this.breadcrumb[3].text = result.name + ' ' + result.lastname;
          }else{
            this.breadcrumb[2].text = '#';
            this.breadcrumb[3].text = result.name;
            result.lastname = '';
          }          
          this.updateAuthorBook();
          return result;
        });
    },
    async updateAuthorBook(){
      this.authorBooks = await axios
        .post(
          this.$store.state.user.siteData.location + "items/books/getForStore",
          JSON.stringify({ page: 1, author: [this.$route.params.id] }),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = [];
          evtResponse.data.records.forEach(element => {
            result.push({
              imgCover:
                this.$store.state.user.siteData.location +
                "repository/books/" +
                element.id +
                "_" +
                element.img,
              bookTitle: element.title,
              bookDesc: element.author,
              bookId: parseInt(element.id),
              bookResume: element.resume,
              bookSubtitle: element.subtitle,
              bookPrice: parseInt(element.price),
              regularCost: parseInt(element.regularcost),
              size: 33,
              promo: element.promo
            });
          });
          return result;
        });
    },
    openLink(link){
      if (link.toLowerCase().substr(0,4) !== 'http'){
        link = 'http://' + link;
      }
      window.open(link);
    }
  }
};
</script>
